export const base64ToBlobUrl = (base64Data, mimeType) => {
  try {
    const base64String = base64Data.replace(/^data:[^;]+;base64,/, "");

    const binaryString = atob(base64String);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: mimeType });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error creating blob URL:", error);
    return null;
  }
};
